import { applyTransform } from 'ol/extent';
import { get as getProjection, getTransform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from '../utils/proj4';
export default function getDefaultViewOptions() {
  // Hungary's projection from https://epsg.io/?format=json&q=23700
  const projectionName = 'EPSG:23700';
  proj4.defs(projectionName, '+proj=somerc +lat_0=47.14439372222222 +lon_0=19.04857177777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs');
  register(proj4);
  const worldExtent = [24.5, 51.5, 14.5, 42];
  const newProj = getProjection(projectionName);
  const fromLonLat = getTransform('EPSG:4326', newProj);
  newProj.setWorldExtent(worldExtent);
  const hungaryExtent = applyTransform(worldExtent, fromLonLat, undefined, 8);
  newProj.setExtent(hungaryExtent);
  const viewOptions = {
    projection: newProj,
    maxZoom: 20,
    minResolution: 0.028,
    zoom: 2,
    extent: hungaryExtent,
    center: [684692.78, 201865.84]
  };
  return viewOptions;
}